import script from "./OsGerarCobrancaPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OsGerarCobrancaPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__